module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Gauge1_16"],"path":[{"$":{"d":"M13.88,7.6a6.84,6.84,0,0,0-1.07-1.41,6.8,6.8,0,0,0-9.62,0A6.85,6.85,0,0,0,2.12,7.6L0,6.4A9.18,9.18,0,0,1,16,6.4Zm-3-1.43L6,11.5V13H7.5l3.93-6.43Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Gauge1_16.svg
// module id = Zgs/
// module chunks = 1